import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { CheckDuplicate } from 'components/CheckDuplicate';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useAddPage from 'hooks/useAddPage';
const SavingsmasterAddPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const api = useApi();
	const utils = useUtils();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		accountnumber: yup.string().required().label($t('accountnumber')),
		groupid: yup.string().nullable().label($t('groupid')),
		memberid: yup.string().required().label($t('memberid')),
		membername: yup.string().nullable().label($t('membername')),
		accountopen_date: yup.string().required().label($t('accountopenDate')),
		documents_ok: yup.array().min(1).label($t('documentsOk')),
		mobile: yup.string().required().label($t('mobile')),
		emailid: yup.string().email().nullable().label($t('emailid')),
		branchcode: yup.string().nullable().label($t('branchcode')),
		empcode: yup.string().nullable().label($t('empcode')),
		signature_image: yup.string().nullable().label($t('signatureImage')),
		photo_image: yup.string().nullable().label($t('photoImage')),
		created_by: yup.number().nullable().label($t('createdBy'))
	});
	
	//form default values
	const formDefaultValues = {
		accountnumber: utils.randomNum(10), 
		groupid: '', 
		memberid: '', 
		membername: '', 
		accountopen_date: new Date(), 
		documents_ok: [], 
		mobile: '', 
		emailid: '', 
		branchcode: '', 
		empcode: '', 
		signature_image: '', 
		photo_image: '', 
		created_by: auth.userId, 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/savingsmaster`);
		}
	}
	
	//auto fill other inputs on memberid change
	async function memberidAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/savingsmaster_memberid_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('membername', data.membername);
formik.setFieldValue('mobile', data.MobileNo);
formik.setFieldValue('emailid', data.email);
formik.setFieldValue('branchcode', data.branchcode);
		}
	};
    //auto fill other inputs on memberid change
    async function memberidAutoFill(e, formik, index) {
        formik.handleChange(e);
        const val = e.target.value;
        const resp = await api.get(`components_data/savingsmaster_memberid_autofill?value=${val}`);
        const data = resp.data[0];
        if(data){
formik.setFieldValue('membername', data.membername);
formik.setFieldValue('mobile', data.mobileNo);
formik.setFieldValue('emailid', data.email);
formik.setFieldValue('branchcode', data.branchcode);
        }
    };
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="SavingsmasterAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewSavingsmaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountnumber')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountnumber"  onChange={formik.handleChange}  value={formik.values.accountnumber}   label={$t('accountnumber')} type="text" placeholder={$t('enterAccountnumber')}     disabled   className={inputClassName(formik?.errors?.accountnumber)} />
                                                <ErrorMessage name="accountnumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('groupid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/groupid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="groupid"     optionLabel="label" optionValue="value" value={formik.values.groupid} onChange={formik.handleChange} options={response} label={$t('groupid')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.groupid)}   />
                                                    <ErrorMessage name="groupid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('memberid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource onLoad={(res) => formik.setFieldValue('memberid', '')} loadOnMount={false} apiPath={`components_data/memberid_option_list_5?lookup_groupid=${formik.values.groupid}`}  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="memberid"     optionLabel="label" optionValue="value" value={formik.values.memberid} onChange={(e)=>memberidAutoFill(e, formik)} options={response} label={$t('memberid')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.memberid)}   />
                                                    <ErrorMessage name="memberid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('membername')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="membername"  onChange={formik.handleChange}  value={formik.values.membername}   label={$t('membername')} type="text" placeholder={$t('enterMembername')}        className={inputClassName(formik?.errors?.membername)} />
                                                <ErrorMessage name="membername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountopenDate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="accountopen_date" showButtonBar className={inputClassName(formik?.errors?.accountopen_date)} dateFormat="yy-mm-dd" value={formik.values.accountopen_date} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="accountopen_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('documentsOk')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className="flex flex-wrap">
                                                    {
                                                    app.menus.deductable.map((option) => {
                                                    return (
                                                    <div key={option.value} className="field-checkbox mx-3">
                                                        <Checkbox inputId={option.value} name="documents_ok" value={option.value} onChange={formik.handleChange} checked={formik.values.documents_ok.includes(option.value)} className={inputClassName(formik?.errors?.documents_ok, '')} />
                                                        <label htmlFor={option.value}>{option.label}</label>
                                                    </div>
                                                    )
                                                    })
                                                    }
                                                </div>
                                                <ErrorMessage name="documents_ok" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mobile')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <CheckDuplicate value={formik.values.mobile} apiPath="components_data/savingsmaster_mobile_exist">
                                                { (checker) => 
                                                <>
                                                <InputText name="mobile" onBlur={checker.check} onChange={formik.handleChange}  value={formik.values.mobile}   label={$t('mobile')} type="text" placeholder={$t('enterMobile')}        className={inputClassName(formik?.errors?.mobile)} />
                                                <ErrorMessage name="mobile" component="span" className="p-error" />
                                                {(!checker.loading && checker.exist) && <small className="p-error">{$t('notAvailable')}</small>}
                                                {checker.loading && <small className="text-500">Checking...</small> }
                                                </>
                                                }
                                                </CheckDuplicate>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('emailid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="emailid"  onChange={formik.handleChange}  value={formik.values.emailid}   label={$t('emailid')} type="email" placeholder={$t('enterEmailid')}        className={inputClassName(formik?.errors?.emailid)} />
                                                <ErrorMessage name="emailid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('branchcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/branchcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="branchcode"     optionLabel="label" optionValue="value" value={formik.values.branchcode} onChange={formik.handleChange} options={response} label={$t('branchcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.branchcode)}   />
                                                    <ErrorMessage name="branchcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/empcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="empcode"     optionLabel="label" optionValue="value" value={formik.values.empcode} onChange={formik.handleChange} options={response} label={$t('empcode')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.empcode)}   />
                                                    <ErrorMessage name="empcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('signatureImage')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.signature_image)}>
                                                    <Uploader name="signature_image" showUploadedFiles value={formik.values.signature_image} uploadPath="fileuploader/upload/signature_image" onChange={(paths) => formik.setFieldValue('signature_image', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="signature_image" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('photoImage')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.photo_image)}>
                                                    <Uploader name="photo_image" showUploadedFiles value={formik.values.photo_image} uploadPath="fileuploader/upload/photo_image" onChange={(paths) => formik.setFieldValue('photo_image', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="photo_image" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('createdBy')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="created_by"  onChange={formik.handleChange}  value={formik.values.created_by}   label={$t('createdBy')} type="number" placeholder={$t('enterCreatedBy')}  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.created_by)} />
                                                <ErrorMessage name="created_by" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
SavingsmasterAddPage.defaultProps = {
	primaryKey: 'accountnumber',
	pageName: 'savingsmaster',
	apiPath: 'savingsmaster/add',
	routeName: 'savingsmasteradd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default SavingsmasterAddPage;
